<div class="sidenav-wrapper">
    <div class="nav-list flex">
    <mat-nav-list>
    </mat-nav-list>
  </div>

</div>
